import { Button, Tab, Tabs, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useDispatch, useSelector } from "react-redux";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import { saveDate } from "../../dateSlice";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
// import { tenant } from "../../tenant"; // No longer needed for REST endpoints
import showToast from "../../utils/toast";
import GenericFileInput from "../genericFileInput";
import GenericForm from "../genericForm";
import "./CalendarStyles.css";
// GraphQL imports removed - now using REST endpoints
import axios from "axios";

export default function JournalDocuments() {
	const authContext = useContext(AuthContext);

	const dispatch = useDispatch();
	const savedState = useSelector((state) => {
		return state.date;
	});
	const [state, setState] = useState(savedState);

	const [categoryOption, setCategoryOption] = React.useState([]);
	const [typeOption, setTypeOption] = React.useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingFile, setLoadingFile] = useState(false);
	const [files, setFiles] = useState([]);
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
	const [newCategoryName, setNewCategoryName] = useState("");
	const [creatingCategory, setCreatingCategory] = useState(false);

	const apiUrl = "/journal-attachments-managment/";

	const [activeTab, setActiveTab] = useState(0);
	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
		setFiles([]);
	};

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	const handleDateChange = (newDate) => {
		setState((prevState) => ({ ...prevState, date: newDate }));
		dispatch(saveDate({ date: newDate }));
		setLoading(true);
		setIsCalendarOpen(false);
	};

	const tileDisabled = ({ date }) => {
		const today = new Date();
		return date > today;
	};

	const fetchCategories = () => {
		apiService
			.get("/tags/")
			.then((data) => {
				if (data && Array.isArray(data)) setCategoryOption(data);
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento delle categorie. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0111165339",
					"error"
				);
			});
	};

	const handleCreateCategory = () => {
		if (!newCategoryName.trim()) {
			handleSetNotification("Il nome della categoria è obbligatorio", "error");
			return;
		}

		setCreatingCategory(true);

		apiService
			.post("/tags/", { "Content-Type": "application/json" }, { name: newCategoryName.trim() })
			.then((data) => {
				if (data && data.id) {
					handleSetNotification("Categoria creata con successo!", "success");
					setNewCategoryName("");
					setOpenCategoryDialog(false);
					fetchCategories();
				} else {
					handleSetNotification("Errore durante la creazione della categoria", "error");
				}
			})
			.catch((error) => {
				console.error("Error creating category:", error);
				handleSetNotification("Errore durante la creazione della categoria. Riprovare più tardi", "error");
			})
			.finally(() => {
				setCreatingCategory(false);
			});
	};

	useEffect(() => {
		fetchCategories();
		apiService
			.get("/attachment-types/", {
				use_on_attachments_area: "true",
			})
			.then((data) => {
				if (data && Array.isArray(data)) setTypeOption(data);
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento dei tipi. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #01111654549",
					"error"
				);
			});
	}, []);

	function getAttachments() {
		setLoading(true);
		apiService
			.get(
				"/journal-attachments-managment",
				{
					area_id: localStorage.getItem("areaSelected"),
					date: dayjs(state.date).format("YYYY-MM-DD"),
					tenant:
						window.location.hostname.split(".")[0] !== "localhost"
							? process.env.REACT_APP_API_URL_BACKEND
							: "http://bottoli.localhost:8000",
				},
				{}
			)
			.then((data) => {
				setFiles(data);
				setLoading(false);
			})
			.catch((error) => {
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento dei file. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #0111125625335",
					"error"
				);
			});
	}

	useEffect(() => {
		getAttachments();
	}, [state.date]);

	const handleSubmit = (fileInfos) => {
		setLoadingFile(true);

		const processedFiles = fileInfos.map((fileInfo) => {
			if (fileInfo.file && fileInfo.file.name && fileInfo.tags) {
				const categoryName = categoryOption.find((cat) => cat.value === fileInfo.tags)?.label || "SCONOSCIUTA";
				const dateStr = dayjs(state.date).format("YYYY-MM-DD");
				const originalName = fileInfo.file.name;
				const fileExtension = originalName.substring(originalName.lastIndexOf("."));
				const fileNameWithoutExt = originalName.substring(0, originalName.lastIndexOf("."));

				const newFileName = `${fileNameWithoutExt}_${categoryName}_${dateStr}${fileExtension}`;

				return {
					...fileInfo,
					file: {
						...fileInfo.file,
						name: newFileName,
					},
				};
			}
			return fileInfo;
		});

		const formData = {
			files: processedFiles,
			date: dayjs(state.date).format("YYYY-MM-DD"),
			area_id: localStorage.getItem("areaSelected"),
		};
		apiService
			.post(apiUrl, {}, formData)
			.then((data) => {
				handleSetNotification("Dati salvati con successo!", "success");
				getAttachments();
				setLoadingFile(false);
			})
			.catch((error) => {
				setLoadingFile(false);
				handleSetNotification(
					"Qualcosaè andato storto durante il salvataggio. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #011112532335",
					"error"
				);
			});
	};

	const inputFieldsTab1 = [
		{ type: "switch", name: "view_on_GDL", label: "Visualizzato su GDL" },
		{
			type: "select",
			name: "tags",
			label: "Categoria",
			options: categoryOption,
			required: true,
		},
		{
			type: "textArea",
			name: "description",
			label: "Descrizione",
			required: false,
		},
	];

	return (
		<>
			<DashboardLayout>
				<DashboardNavbar />
				{authContext.hasAuth("VIEW_ATTACHMENTAREA") ? (
					<>
						<center style={{ marginBottom: "25px" }}>
							<MDTypography variant="h2" fontWeight="bold">
								Carica allegati
							</MDTypography>
							<div className="calendar-container">
								<div
									style={{
										display: !isCalendarOpen ? "none" : "block",
									}}
								>
									<Calendar
										onChange={handleDateChange}
										value={state.date}
										tileDisabled={tileDisabled}
										maxDate={new Date()}
										className="custom-calendar"
									/>
								</div>
								<div
									style={{
										marginTop: "16px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: "16px",
										flexWrap: "wrap",
										marginBottom: "30px",
									}}
								>
									<Button
										variant="contained"
										color="primary"
										onClick={() => setIsCalendarOpen(!isCalendarOpen)}
										sx={{
											minWidth: "120px",
											color: "#ffffff",
										}}
									>
										{isCalendarOpen ? "Chiudi calendario" : "Apri calendario"}
									</Button>
									<MDTypography fontWeight="bold" textTransform="uppercase">
										{state.date.toLocaleDateString("it-IT", {
											weekday: "long",
											year: "numeric",
											month: "2-digit",
											day: "2-digit",
										})}
									</MDTypography>
								</div>
							</div>
						</center>

						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								marginBottom: "20px",
							}}
						>
							<Button
								variant="outlined"
								onClick={() => setOpenCategoryDialog(true)}
								sx={{
									color: "#2196f3",
								}}
							>
								Crea Nuova Categoria
							</Button>
						</Box>

						{loadingFile && (
							<div>
								<center>
									<CircularProgress size={80} sx={{ marginTop: "50px" }} />
								</center>
								<text>Sto caricando i file, l'operazione potrebbe richiedere alcuni minuti...</text>
							</div>
						)}
						{!loading ? (
							<>
								<GenericFileInput
									onSubmit={handleSubmit}
									authModelName={"ATTACHMENTAREA"}
									inputFields={inputFieldsTab1}
									files={files}
								/>
							</>
						) : (
							<center>
								<CircularProgress size={80} sx={{ marginTop: "50px" }} />
							</center>
						)}

						<Dialog open={openCategoryDialog} onClose={() => setOpenCategoryDialog(false)} maxWidth="sm" fullWidth>
							<DialogTitle>Crea Nuova Categoria</DialogTitle>
							<DialogContent>
								<TextField
									autoFocus
									margin="dense"
									label="Nome Categoria"
									fullWidth
									variant="outlined"
									value={newCategoryName}
									onChange={(e) => setNewCategoryName(e.target.value)}
									disabled={creatingCategory}
								/>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => setOpenCategoryDialog(false)} disabled={creatingCategory}>
									Annulla
								</Button>
								<Button onClick={handleCreateCategory} disabled={creatingCategory || !newCategoryName.trim()}>
									{creatingCategory ? <CircularProgress size={20} /> : "Crea"}
								</Button>
							</DialogActions>
						</Dialog>
					</>
				) : (
					<MDAlert color="error" dismissible>
						<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
					</MDAlert>
				)}
			</DashboardLayout>
		</>
	);
}
